import { Component, OnDestroy } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Subject, concat, of } from 'rxjs';
import { takeUntil, startWith, filter, debounceTime, distinctUntilChanged, switchMap, tap, catchError } from 'rxjs/operators';

@Component({
  selector: 'eos-type-ahead-select',
  template: `
  <ng-select [items]="options$ | async"
      [placeholder]="to.placeholder"
      [typeahead]="searchInput$"
      bindLabel="displayText"      
      [formControl]="formControl">
      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
      <div><span>{{item.displayText}}</span></div>
    </ng-template>
    </ng-select>
  `,
})

export class TypeAheadSelectComponent extends FieldType implements OnDestroy {
  onDestroy$ = new Subject<void>();
  searchInput$ = new Subject<string>();
  options$;
  showLoader = false;

  constructor() {
    super();
  }

  ngOnInit() {
    this.options$ =
      this.searchInput$.pipe(
        takeUntil(this.onDestroy$),
        startWith(''),
        filter(v => v !== null),
        debounceTime(200),
        distinctUntilChanged(),
        switchMap(this.to.searchInput$)
      );

    this.options$.subscribe();
  }

  ngOnDestroy() {
    this.onDestroy$.complete();
  }
}
